<template>
  <v-snackbar :value="snackbar" @input="$emit('close')">
    {{ snackbarText }}
    <v-btn color="accent" text @click="$emit('close')">Close</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'SnackbarMessage',
  props: {
    snackbar: Boolean,
    snackbarText: String
  }
}
</script>

<style scoped></style>
